import { QaEquipmentCatalogDto, QaEquipmentRtSystemDto } from '@/api/generator';
import { truthy } from '@/utils/helper';
import { NamedGroup, useNamedGroups } from '@/utils/namedGroup';
import { computed, MaybeRefOrGetter, toRef, ComputedRef } from 'vue';
import { subCategoryCompare } from './sortedQaEquipment';

export function useSupportSystemGroups(
  idGroups: MaybeRefOrGetter<NamedGroup<string>[] | undefined>,
  allSupportSystems: MaybeRefOrGetter<QaEquipmentCatalogDto[] | undefined>,
): {
  supportSystems: ComputedRef<QaEquipmentCatalogDto[] | undefined>;
  supportSystemGroups: ComputedRef<Record<string, QaEquipmentCatalogDto[]> | undefined>;
  numGroups: ComputedRef<number>;
};

export function useSupportSystemGroups(
  idGroups: MaybeRefOrGetter<NamedGroup<string>[] | undefined>,
  allSupportSystems: MaybeRefOrGetter<QaEquipmentRtSystemDto[] | undefined>,
): {
  supportSystems: ComputedRef<QaEquipmentRtSystemDto[] | undefined>;
  supportSystemGroups: ComputedRef<Record<string, QaEquipmentRtSystemDto[]> | undefined>;
  numGroups: ComputedRef<number>;
};

export function useSupportSystemGroups(
  idGroups: MaybeRefOrGetter<NamedGroup<string>[] | undefined>,
  allSupportSystems: MaybeRefOrGetter<
    (QaEquipmentCatalogDto | QaEquipmentRtSystemDto)[] | undefined
  >,
) {
  const allSupportSystemsRef = toRef(allSupportSystems);

  const { allEntries, groupRecord, numGroups } = useNamedGroups(toRef(idGroups));

  const supportSystems = computed(() =>
    allSupportSystemsRef.value
      ?.filter(({ id }) => allEntries.value?.includes(id))
      .toSorted(subCategoryCompare),
  );

  const supportSystemGroups = computed(() =>
    groupRecord.value
      ? Object.entries(groupRecord.value).reduce<
          Record<string, (QaEquipmentRtSystemDto | QaEquipmentCatalogDto)[]>
        >((systemGroups, [groupName, systemIds]) => {
          const systems = systemIds
            .map((id: string) => supportSystems.value?.find((system) => system.id === id))
            .filter(truthy)
            .toSorted(subCategoryCompare);

          return systems
            ? {
                ...systemGroups,
                [groupName]: systems,
              }
            : systemGroups;
        }, {})
      : undefined,
  );

  return {
    supportSystems,
    supportSystemGroups,
    numGroups,
  };
}
